import { useEffect } from 'react'
import { withRouter } from '../../hooks/withRouter'

function ScrollToTop({ history }) {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [history])

  return null
}

export default withRouter(ScrollToTop)
